import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type ConfirmEmailBannerFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id' | 'aaId' | 'confirmed' | 'email' | 'isAaMastered'>
);

export const ConfirmEmailBannerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConfirmEmailBanner' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'aaId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isAaMastered' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseConfirmEmailBannerFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      ConfirmEmailBannerFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseConfirmEmailBannerFragmentResult
  extends Omit<Apollo.UseFragmentResult<ConfirmEmailBannerFragment>, 'data'> {
  data?: ConfirmEmailBannerFragment;
}

export const useConfirmEmailBannerFragment = ({
  from,
  returnPartialData,
  ...options
}: UseConfirmEmailBannerFragmentOptions): UseConfirmEmailBannerFragmentResult => {
  const result = Apollo.useFragment<ConfirmEmailBannerFragment>({
    ...options,
    fragment: ConfirmEmailBannerFragmentDoc,
    fragmentName: 'ConfirmEmailBanner',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as ConfirmEmailBannerFragment };
};
